import React from 'react';
const Gym = () => <div className="service-page"><h1>Gyms</h1><p>Find the best gyms and fitness centers near you.</p></div>;
export default Gym;
